<template>
  <Modal v-model="visible" width="900" title="批量复制操作" class-name="vertical-center-modal" :mask-closable="false">
    <el-table ref="table" stripe border :max-height="520" :columns="columns" :data="data">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'copyPlan'">
            <span v-if="scope.row.length">
              可批量复制 {{ scope.row.copyPlan.join('，') }} 等
              <strong style="color: red">{{ scope.row.length }}</strong>
              条计划
            </span>
          </div>
          <div v-else-if="col.key === 'control'">
            <template v-if="[10, 16, -10, -20, -30, -40, 6, 32, 45].includes(scope.row.mediaId)">
              <Button type="primary" @click="toBatchEdit(scope.row, 'split')"> 分开复制 </Button>

              <Button style="margin-left: 10px" v-if="scope.row.megerCreative" type="primary" @click="toBatchEdit(scope.row, 'merge')">
                合并复制
              </Button>
            </template>

            <span v-else>暂不支持</span>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setSession } from '@/common/js/api'
import { setLocalInfo, setStoreName, camelcase } from '@/common/js/utils'
export default {
  name: 'batchCopy',
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getOpenUrl(media) {
      if (media === 10) return '/edit/local?t=copy'
      else if (media === 16) return '/edit/tencent?t=copy'
      // else if (media === -10) return '/edit/toutiao?t=copy'
      else if (media === -10) return '/duplicate/toutiaov2'
      else if (media === -20) return '/duplicate/tencentada'
      else if (media === -30) return '/duplicate/tencentv3'
      else if (media === -40) return '/duplicate/toutiaov2'
      else if (media === 6) return '/edit/uc?t=copy'
      else if (media === 32) return '/duplicate/kuaishou'
      else if (media === 45) return '/duplicate/baidu'
      else return ''
    },
    toBatchEdit(row, flag) {
      const { mediaId, planInfos } = row
      if (mediaId === -10) {
        // 头条2.0
        const account = Cookies.get('ch_user_name')
        const id = Cookies.get('ch_op_id')
        const openUrl = this.getOpenUrl(-10)

        setSession(
          'taskIds',
          planInfos.map((ret) => ret.taskId)
        )
        setSession('taskRows', planInfos)
        setLocalInfo(id, account, String(10))
        this.$store.commit('Local/setMedia', 10)
        this.$store.commit('Local/setOpId', id)
        this.$store.commit('Local/setAdmin', 10)
        window.open(openUrl, '_blank')
      } else if (mediaId === -20) {
        // 腾讯广告ada
        const openUrl = this.getOpenUrl(-20)

        setSession(
          'taskIds',
          planInfos.map((ret) => ret.taskId)
        )
        window.open(openUrl, '_blank')
      } else if (mediaId === -30 || mediaId === 16) {
        // 腾讯广告v3

        // 20250621天假
        // mediaId === 16 为腾讯广告v1的搜索广告
        const openUrl = this.getOpenUrl(-30)

        setSession(
          'taskIds',
          planInfos.map((ret) => ret.taskId)
        )
        // row.megerCreative: src/views/promote/plandata/components/detail-table.vue  [changeBetch]
        window.open(flag === 'merge' ? openUrl + '?type=megercreatives' : openUrl, '_blank')
      } else if (mediaId === -40) {
        const openUrl = this.getOpenUrl(-40)

        setSession(
          'taskIds',
          planInfos.map((ret) => ret.taskId)
        )
        window.open(openUrl, '_blank')
      } else {
        const account = Cookies.get('ch_user_name')
        const id = Cookies.get('ch_op_id')
        const openUrl = this.getOpenUrl(mediaId)
        const storeName = setStoreName(mediaId)

        setSession(
          'taskIds',
          planInfos.map((ret) => ret.taskId)
        )
        setSession('taskRows', planInfos)
        setLocalInfo(id, account, String(mediaId))
        this.$store.commit(`${camelcase(storeName)}/setMedia`, mediaId)
        this.$store.commit(`${camelcase(storeName)}/setOpId`, id)
        this.$store.commit(`${camelcase(storeName)}/setAdmin`, account)
        window.open(openUrl, '_blank')
      }
    }
  }
}
</script>
